import { APIHandler, DataHandler, StorageHandler } from 'C4';
import { storageKeys } from 'settings';

const AppSettings = async () => {
  const appId = await DataHandler.matchAppId();
  const appInfo = await APIHandler.getAppInfo(appId);

  if (appInfo) {
    const { logo, landingVideo, logo_white, general_background_image, landing_quote } = appInfo.app[0];
    const appInfoObject = {
      logo: logo?.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com'),
      secondaryLogo: logo_white?.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com'),
      background: general_background_image?.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com'),
      video: landingVideo?.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com'),
      landingQuote: landing_quote,
    };

    StorageHandler.save(storageKeys.appInfo, appInfoObject);

    return true;
  }
};

export default AppSettings;
